import { createTheme } from '@mui/material/styles'
import createPalette from '@mui/material/styles/createPalette'

export const COLOR_PRIMARY = 'rgb(25, 118, 210)' // blue
export const COLOR_SECONDARY = '#69716f' // dark blue light
export const COLOR_DANGER = '#e93f3f'
export const COLOR_WARNING = '#ff9f00'
export const COLOR_BGDISABLED = '#eee'

export const palette = createPalette({
    primary: { main: COLOR_PRIMARY },
    secondary: { main: COLOR_SECONDARY },
    error: { main: COLOR_DANGER },
    warning: { main: COLOR_WARNING },
})

export const theme = createTheme({
    palette,
    typography: {
        fontSize: 13,
    },
    components: {
        MuiPaper: {
            styleOverrides: {
                root: {
                    color: '#69716f',
                },
            },
        },
        MuiDivider: {
            styleOverrides: {
                root: {
                    marginBottom: 20,
                },
            },
        },
        MuiInputBase: {
            styleOverrides: {
                input: {
                    padding: '10px 14px !important',
                    '&.Mui-disabled': {
                        backgroundColor: COLOR_BGDISABLED,
                    },
                },
                root: {
                    '&.Mui-disabled': {
                        backgroundColor: COLOR_BGDISABLED,
                    },
                },
                inputMultiline: {
                    padding: `0 !important`,
                    minHeight: 60,
                },
            },
        },
        MuiButton: {
            styleOverrides: {
                textPrimary: {
                    color: '#fff',
                },
                textSecondary: {
                    color: '#000',
                },
            },
        },
        MuiAutocomplete: {
            styleOverrides: {
                inputRoot: {
                    padding: '0px !important',
                },
                input: {
                    padding: '10px 14px !important',
                },
            },
        },
        MuiAlert: {
            styleOverrides: {
                filledWarning: {
                    text: '#fff',
                },
            },
        },
        MuiFormControl: {
            styleOverrides: {
                root: {
                    '& fieldset': {
                        top: '0px !important',
                    },
                    '& legend': {
                        display: 'none !important',
                    },
                },
            },
        },
    },
})
